module.exports = __webpack_public_path__ + "static/background-679457e2d0a1b4717c9419c3ab2f2ce3.jpg";